import { FormInstance } from "antd/es/form";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUcak_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUcak_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  SelectUcak: any[];
  SelectUcak_dummy: any[];
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  isCompucak_form_69490AuthorizationVisible: "visible" | "hidden";
  isCompucak_form_9544AuthorizationVisible: "visible" | "hidden";
}

export class Ucak_Form_ScreenBase extends React.PureComponent<
  IUcak_Form_ScreenProps,
  any
> {
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "2ea77971-661d-417b-b712-fb05e46582c5",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Uçak Formu" },
        { Id: 69490, PropertyName: "label", Value: "Tarihçe" },
        { Id: 8099909, PropertyName: "value", Value: "Ad" },
        { Id: 1623830, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 7590664, PropertyName: "value", Value: "Son Taco" },
        { Id: 3912261, PropertyName: "placeholder", Value: "15" },
        { Id: 8594493, PropertyName: "value", Value: "Bakıma Kalan Taco" },
        { Id: 4018624, PropertyName: "placeholder", Value: "15" },
        { Id: 9544, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.ucak_form_1623830_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      GoBack: "",
      SelectUcak: [],
      SaveRecord_1: 0,
      isCompucak_form_69490AuthorizationVisible: "visible",
      isCompucak_form_9544AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("ucak_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.Ucak_FormPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompucak_form_69490AuthorizationVisible",
      [
        "41b245b2-8248-872c-382e-02ee2ce9c846",
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "FLYPILOT",
        "FLYADMIN",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompucak_form_9544AuthorizationVisible",
      [
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "41b245b2-8248-872c-382e-02ee2ce9c846",
        "cf733353-6d36-8127-9f8b-a3aed724696b",
        "FLYPILOT",
        "FLYTEKNISYEN",
        "FLYADMIN",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("ucak_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "FLYPILOT",
      "FLYTEKNISYEN",
      "FLYADMIN",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("ucak_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.Ucak_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      ucak_form_1623830_value: this.state.SelectUcak?.at?.(0)?.ad ?? undefined,
      ucak_form_3912261_value:
        this.state.SelectUcak?.at?.(0)?.sonTaco ?? undefined,
      ucak_form_4018624_value:
        this.state.SelectUcak?.at?.(0)?.bakimTaco ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  Ucak_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Ucak_Form/Ucak_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectUcak = result?.data.selectUcak;
    formVars.ucak_form_1623830_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectUcak !== undefined
        ? stateVars.SelectUcak?.length > 0
          ? stateVars.SelectUcak[0].ad
          : null
        : this.state.SelectUcak?.length > 0
        ? this.state.SelectUcak[0].ad
        : null
    );
    formVars.ucak_form_3912261_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectUcak !== undefined
        ? stateVars.SelectUcak?.length > 0
          ? stateVars.SelectUcak[0].sonTaco
          : null
        : this.state.SelectUcak?.length > 0
        ? this.state.SelectUcak[0].sonTaco
        : null
    );
    formVars.ucak_form_4018624_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectUcak !== undefined
        ? stateVars.SelectUcak?.length > 0
          ? stateVars.SelectUcak[0].bakimTaco
          : null
        : this.state.SelectUcak?.length > 0
        ? this.state.SelectUcak[0].bakimTaco
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Ucak_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Ucak_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.ucak_form_1623830_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectUcak !== undefined
        ? stateVars.SelectUcak?.length > 0
          ? stateVars.SelectUcak[0].ad
          : null
        : this.state.SelectUcak?.length > 0
        ? this.state.SelectUcak[0].ad
        : null
    );

    formVars.ucak_form_3912261_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectUcak !== undefined
        ? stateVars.SelectUcak?.length > 0
          ? stateVars.SelectUcak[0].sonTaco
          : null
        : this.state.SelectUcak?.length > 0
        ? this.state.SelectUcak[0].sonTaco
        : null
    );

    formVars.ucak_form_4018624_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectUcak !== undefined
        ? stateVars.SelectUcak?.length > 0
          ? stateVars.SelectUcak[0].bakimTaco
          : null
        : this.state.SelectUcak?.length > 0
        ? this.state.SelectUcak[0].bakimTaco
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  Ucak_FormComponent_69490_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterTablo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Fly.Ucak", "string"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Ekleyen",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectUcak !== undefined
            ? stateVars.SelectUcak?.length > 0
              ? stateVars.SelectUcak[0].ekleyen
              : null
            : this.state.SelectUcak?.length > 0
            ? this.state.SelectUcak[0].ekleyen
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Degistiren",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectUcak !== undefined
            ? stateVars.SelectUcak?.length > 0
              ? stateVars.SelectUcak[0].degistiren
              : null
            : this.state.SelectUcak?.length > 0
            ? this.state.SelectUcak[0].degistiren
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "EklemeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectUcak !== undefined
            ? stateVars.SelectUcak?.length > 0
              ? stateVars.SelectUcak[0].eklemeZamani
              : null
            : this.state.SelectUcak?.length > 0
            ? this.state.SelectUcak[0].eklemeZamani
            : null
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "DegistitirmeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectUcak !== undefined
            ? stateVars.SelectUcak?.length > 0
              ? stateVars.SelectUcak[0].degistirmeZamani
              : null
            : this.state.SelectUcak?.length > 0
            ? this.state.SelectUcak[0].degistirmeZamani
            : null
        ),
        "Date"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Ucak_Form",
      "TarihceList",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "26071",
      null,
      "right",
      "False",
      "100vw",
      "100vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Ucak_FormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Ucak_FormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Ad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucak_form_1623830_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Degistiren_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      DegistirmeZamani_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      BakimTaco_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucak_form_4018624_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SonTaco_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucak_form_3912261_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_0_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Ucak_Form/Ucak_FormComponent_9544_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_1 = result?.data.saveRecord_1;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Ucak_FormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Ucak_FormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.Ucak_FormPageInit();
    }
  }
}
